<div class="status-filter">
  <rotec-checkbox-with-label-v2
    [darkMode]="true"
    [item]="redCheckbox"
    (status)="toggleValue({ name: 'Red', value: 100 }, $event)"
  ></rotec-checkbox-with-label-v2>
  <rotec-checkbox-with-label-v2
    [darkMode]="true"
    [item]="orangeCheckbox"
    (status)="toggleValue({ name: 'Orange', value: 80 }, $event)"
  ></rotec-checkbox-with-label-v2>
  <rotec-checkbox-with-label-v2
    [darkMode]="true"
    [item]="greenCheckbox"
    (status)="toggleValue({ name: 'Green', value: 0 }, $event)"
  ></rotec-checkbox-with-label-v2>

  <div class="percentage">
    <rotec-checkbox-with-label-v2
      [darkMode]="true"
      [item]="percentageCheckbox"
      (status)="toggleValue({ name: 'Percentage', value: percentageValue }, $event)"
    ></rotec-checkbox-with-label-v2>
    <span><=</span>
    <rotec-number-input-v2
      [darkMode]="true"
      [min]="0"
      [max]="100"
      [value]="percentageValue"
      (valueChange)="changeInputValue($event)"
    ></rotec-number-input-v2>
  </div>
</div>
